export default "__VITE_ASSET__7pmQDrfq__"